import meta from './meta';
import { Translate } from 'next-translate';

export function capitalized(str: string): string {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

export function resolveMeta(
  path: string,
  query: any,
  locale: string,
  t: Translate,
  initialData: Record<string, unknown> = {},
): Record<symbol, string> {
  // Find meta for the route (title, description, etc)
  const matchedMeta =
    Object.keys(meta).reduce((acc, key) => {
      if (new RegExp(`${key}$`, 'i').test(path)) {
        acc = meta[key];
      }
      return acc;
    }, {}) || meta[path];

  const metaObj = { ...meta.DEFAULT, ...matchedMeta };

  metaObj.title = unescape(metaObj.getTitle(metaObj, locale, t, { ...query, ...initialData }).replace(/\s+/g, ' '));
  metaObj.description = metaObj.getDescription(metaObj, locale, t, { ...query, ...initialData }).replace(/\s+/g, ' ');

  return metaObj;
}

export function addLocationToMeta(strSrc: string, locationName: string): string {
  return strSrc.replace(/\[location\]/g, capitalized(locationName));
}
